import React from 'react';
import authService from '../services/authService';
import './Header.css';

const Header = ({ onSearch, searchTerm, selectedCategory, onCategoryChange, categories, onViewAdmin, currentView, showAdminButton }) => {
  const handleLogout = async () => {
    try {
      await authService.logout();
      // Refresh the page to reset the app state
      window.location.reload();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="header-left">
            <div className="header-title">
              <h1>CareTria AI Hub</h1>
              <p>Your AI-Powered Business Applications Dashboard</p>
            </div>
          </div>
          
          <div className="header-center">
            {currentView === 'dashboard' && (
              <>
                <div className="search-container">
                  <div className="search-input-wrapper">
                    <span className="search-icon">🔍</span>
                    <input
                      type="text"
                      placeholder="Search applications..."
                      value={searchTerm}
                      onChange={(e) => onSearch(e.target.value)}
                      className="search-input"
                    />
                  </div>
                </div>
                
                <div className="category-filter">
                  <select
                    value={selectedCategory}
                    onChange={(e) => onCategoryChange(e.target.value)}
                    className="category-select"
                  >
                    <option value="">All Categories</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.icon} {category.name}
                      </option>
                    ))}
                  </select>
                </div>
                
                {showAdminButton && (
                  <button 
                    onClick={onViewAdmin}
                    className="admin-button"
                  >
                    🔧 Admin Panel
                  </button>
                )}
              </>
            )}
          </div>
          
          <div className="header-right">
            {authService.isAuthenticated && (
              <button 
                onClick={handleLogout}
                className="auth-button logout-button"
              >
                🚪 Logout
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
